const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const WXDOMAIN = `//wx${spell}.xinli001.com/`,

  CPDOMAIN = `//m-cpapi${spell}.xinli001.com/`,

  LXDOMAIN = spell?`//lingxi${spell}.xinli001.com/lingxi/service/`:`//m-lingxi${spell}.xinli001.com/lingxi/service/`,
  CPAPI = spell?`//cpapi${spell}.xinli001.com/cp/service/`:`//m-cpapi${spell}.xinli001.com/cp/service/`,
  LX = `//lx${spell}.xinli001.com/lx/`,
  FUN = `//qu${spell}.xinli001.com/lingxi/fun/`,
  YIAPIDOMAIN = `//yiapi${spell}.xinli001.com`,
  MDOMAIN = `//m${spell}.xinli001.com`,
  // PGXINLI = `//appoint${spell}.pgxinli.com`,
  // MDOMAIN = `//m.xinli001.com`,
  PGXINLI = `//appoint.pgxinli.com`,
  HCP = `//hcp${spell}.xinli001.com`,
  CPBADMIN = `//cpbadmin${spell}.xinli001.com`;

export default {
  env, spell, WXDOMAIN,  CPAPI, LX, FUN, YIAPIDOMAIN, MDOMAIN, PGXINLI, HCP, CPBADMIN,LXDOMAIN
}


// WEBPACK FOOTER //
// ./src/apis/apiConfig.js